import { Checkbox, Dropdown, Flex, Row, Space, Button } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const EmployeeModalTable = ({
    currentCalendar = {},
    dataSource = [],
    onEdit = () => { },
    onDelete = () => { },
    onSubmit = () => { },
    onCancel = () => { },
    save = "SAVE",
    back = "BACK"
}) => {
    const isLoading = useSelector((state) => state.holidayCalendar.isLoading);
    const { t, i18n } = useTranslation();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    const onSelectChange = (selectedKeys) => {
        setSelectedRowKeys(selectedKeys);
    };

    const handleCheckboxChange = (e, record) => {
        const { checked } = e.target;
        const newSelectedRowKeys = checked
            ? [...selectedRowKeys, record.id]
            : selectedRowKeys.filter(key => key !== record.id); // Remove unselected row
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const columns = [
        // {
        //     dataIndex: "0",
        //     key: "0",
        //     index: dataSource?.id,
        //     render: (text, record, index) => (
        //         <Checkbox
        //             onChange={(e) => handleCheckboxChange(e, record)}
        //             checked={selectedRowKeys.includes(record.id)}
        //         />
        //     ),
        // },
        {
            title: (
                <div className="text-table">
                    {t('salary.label.employee_no')}
                </div>
            ),
            name: "employeeNo",
            dataIndex: "employeeNo",
            key: "employeeNo",

        },
        {
            title: <div className="text-table">{t('employee.label.employee-name')}</div>,
            dataIndex: "employeeName",
            key: "employeeName",
            render: (_, record) => {
                if (record?.nameEn || record?.name) {
                    return i18n.language === 'en' ? record?.nameEn + ' ' + record?.surNameEn : record?.name + ' ' + record?.surName
                }

            }
        },
    ];

    return (
        <>
            <Flex vertical >
                <TableAntd
                    loading={isLoading}
                    pagination={false}
                    dataSource={dataSource}
                    rowKey={(record) => record?.id}
                    columns={columns}
                    rowSelection={{
                        selectedRowKeys,
                        onChange: onSelectChange,
                    }}
                    style={{ width: "100%" }}
                    scroll={{ x: true }}
                />
                <Row justify='space-between' style={{ marginTop: "12px" }}>
                    <Flex align="center">
                        <span>{i18n.language === "en"
                            ? `Selected ${selectedRowKeys.length} employees`
                            : `เลือกแล้ว ${selectedRowKeys.length} คน`}</span>
                    </Flex>
                    <Space direction="horizontal" >
                        <Button
                            type="default"
                            id="organization__cancelBtn"
                            key="back"
                            onClick={() => {
                                onCancel();
                                // resetForm();
                            }}
                            style={{ borderRadius: "8px", height: "40px" }}
                        >
                            {/* {back} */}
                            {t("common.cancel")}
                        </Button>
                        <Button
                            htmlType="submit"
                            type="primary"
                            onClick={() => {
                                const modified = {
                                    holidayCalendarGroupId: currentCalendar?.holidayCalendarGroupId,
                                    employeeListId: selectedRowKeys
                                }
                                onSubmit(modified)
                                setSelectedRowKeys([])
                            }}
                            style={{ backgroundColor: "var(--button-color)", borderRadius: "8px", height: "40px", boxShadow: "none" }}
                        >
                            {/* {save} */}
                            {t("common.save")}
                        </Button>
                    </Space>
                </Row>
            </Flex>
        </>
    );
};

export default EmployeeModalTable;
